import { PipelineSourceSyncRunsPage } from './-components';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/pipelines/sources/$sourceId/imports')({
  component: PipelineSourceSyncRunsPage,
});
